import React, { useState, useEffect } from "react";

function PlanoForm({ plano, onChange, onCancel, onSave }) {
  // Inclua qt_minima e qt_maxima nos valores padrão e ao editar
  const defaultForm = {
    cod_prod: "",
    produto: "",
    cod_ans: "",
    idade_minima: "",
    idade_maxima: "",
    qt_minima: "",
    qt_maxima: "",
    id_exclusivo: "",
    observacao: "",
    Segmentacao: "",
    Acomodacao: "",
    Abrangencia: "",
    Coparticipacao: "",
    ATIVO: "A",
    ...Object.fromEntries(Array.from({ length: 10 }, (_, i) => [
      `faixa${i}_id_inicio`, ""
    ])),
    ...Object.fromEntries(Array.from({ length: 10 }, (_, i) => [
      `faixa${i}_id_fim`, ""
    ])),
    ...Object.fromEntries(Array.from({ length: 10 }, (_, i) => [
      `faixa${i}`, ""
    ])),
  };

  const [form, setForm] = useState(plano || defaultForm);
  const [mensagem, setMensagem] = useState("");

  useEffect(() => {
    setForm(plano || defaultForm);
    setMensagem("");
  }, [plano]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
    if (onChange) onChange({ ...form, [name]: value });
  };

  // --- AJUSTE: SÓ ESSA VERSÃO DE handleSubmit ---
  const handleSubmit = (e) => {
    e.preventDefault();
    setMensagem("");
    if (!form.produto || !form.cod_prod || !form.cod_ans) {
      setMensagem("Preencha produto, código do produto e código ANS.");
      return;
    }

    // Monta payload convertendo campos numéricos
    const payload = {
      cod_prod: Number(form.cod_prod),
      produto: form.produto,
      cod_ans: Number(form.cod_ans),
      idade_minima: Number(form.idade_minima),
      idade_maxima: Number(form.idade_maxima),
      qt_minima: Number(form.qt_minima),
      qt_maxima: Number(form.qt_maxima),
      id_exclusivo: form.id_exclusivo,
      observacao: form.observacao,
      Segmentacao: form.Segmentacao,
      Acomodacao: form.Acomodacao,
      Abrangencia: form.Abrangencia,
      Coparticipacao: form.Coparticipacao,
      ...Object.fromEntries(
        Array.from({ length: 10 }, (_, i) => [
          `faixa${i}_id_inicio`, Number(form[`faixa${i}_id_inicio`] || 0)
        ])
      ),
      ...Object.fromEntries(
        Array.from({ length: 10 }, (_, i) => [
          `faixa${i}_id_fim`, Number(form[`faixa${i}_id_fim`] || 0)
        ])
      ),
      ...Object.fromEntries(
        Array.from({ length: 10 }, (_, i) => [
          `faixa${i}`, Number(form[`faixa${i}`] || 0)
        ])
      ),
    };

    if (onSave) onSave({ ...form, ...payload });
  };
  // --- FIM DO AJUSTE ---

  const labelStyle = {
    fontWeight: 500,
    fontSize: 15,
    color: "#757575",
    marginBottom: 4,
    display: "block",
  };

  const inputStyle = {
    width: "100%",
    border: "1.5px solid #d3d7e0",
    borderRadius: 12,
    padding: "10px 14px",
    fontSize: 15,
    color: "#555",
    background: "#f8fafd",
    marginBottom: 0,
    outline: "none",
    boxSizing: "border-box"
  };

  const faixas = Array.from({ length: 10 }, (_, i) => i);

  // ADICIONE ESTA LINHA:
  const tipoUsuario = localStorage.getItem("tipo_usuario")?.toUpperCase();

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        background: "#fff",
        borderRadius: 20,
        padding: 32,
        maxWidth: 680,
        margin: "0 auto",
        boxShadow: "0 8px 32px rgba(0,0,0,0.07)",
        display: "flex",
        flexDirection: "column",
        gap: 18,
      }}
    >
      <h3 style={{
        marginTop: 0,
        color: "#222",
        fontWeight: 700,
        fontSize: 22,
        marginBottom: 12
      }}>
        {plano ? "Editar Plano" : "Novo Plano1"}
      </h3>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
        <div>
          <label style={labelStyle}>Cod. Produto *</label>
          <input name="cod_prod" value={form.cod_prod} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Cod. ANS *</label>
          <input name="cod_ans" value={form.cod_ans} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Produto *</label>
          <input name="produto" value={form.produto} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Segmentação</label>
          <input name="Segmentacao" value={form.Segmentacao} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Acomodação</label>
          <input name="Acomodacao" value={form.Acomodacao} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Abrangência</label>
          <input name="Abrangencia" value={form.Abrangencia} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Coparticipação</label>
          <input name="Coparticipacao" value={form.Coparticipacao} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Idade Inicial</label>
          <input name="idade_minima" value={form.idade_minima} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Idade Final</label>
          <input name="idade_maxima" value={form.idade_maxima} onChange={handleInputChange} style={inputStyle} />
        </div>
        {/* Novos campos */}
        <div>
          <label style={labelStyle}>Qtd. Mínima</label>
          <input name="qt_minima" value={form.qt_minima} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Qtd. Máxima</label>
          <input name="qt_maxima" value={form.qt_maxima} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div>
        <label style={labelStyle}>ID Exclusivo</label>
        <input name="id_exclusivo" value={form.id_exclusivo} onChange={handleInputChange} style={inputStyle}/>
        </div>
      </div>
      <div style={{ margin: "12px 0 0 0", fontWeight: 600 }}>Faixas Etárias:</div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 }}>
        {faixas.map(i => (
          <React.Fragment key={i}>
            <div>
              <label style={labelStyle}>{`Faixa ${i} - Início`}</label>
              <input name={`faixa${i}_id_inicio`} value={form[`faixa${i}_id_inicio`]} onChange={handleInputChange} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>{`Faixa ${i} - Fim`}</label>
              <input name={`faixa${i}_id_fim`} value={form[`faixa${i}_id_fim`]} onChange={handleInputChange} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>{`Faixa ${i} - Valor`}</label>
              <input name={`faixa${i}`} value={form[`faixa${i}`]} onChange={handleInputChange} style={inputStyle} />
            </div>
          </React.Fragment>
        ))}
      </div>
      <div>
        <label style={labelStyle}>Observação</label>
        <textarea
          name="observacao"
          value={form.observacao}
          onChange={handleInputChange}
          style={{ ...inputStyle, minHeight: 60, resize: "vertical" }}
          placeholder="Qualquer observação relevante..."
        />
      </div>
      {mensagem && (
        <div style={{ color: mensagem.includes("sucesso") ? "#00b894" : "#d63031", marginBottom: 12, textAlign: "center" }}>
          {mensagem}
        </div>
      )}

      {/* BOTÕES APENAS PARA ADMIN */}
      {tipoUsuario === "A" && (
        <div style={{ display: "flex", gap: 14, marginTop: 18 }}>
          <button type="submit" style={{
            flex: 1,
            background: "#00bcd4",
            color: "#fff",
            border: 0,
            borderRadius: 12,
            padding: "14px 0",
            fontWeight: 600,
            fontSize: 16,
            boxShadow: "0 1px 8px rgba(0,188,212,0.08)",
            cursor: "pointer",
            transition: "background 0.2s"
          }}>
            Salvar
          </button>
          <button type="button" onClick={onCancel} style={{
            flex: 1,
            background: "#f4f4f4",
            color: "#666",
            border: 0,
            borderRadius: 12,
            padding: "14px 0",
            fontWeight: 500,
            fontSize: 16,
            boxShadow: "0 1px 4px rgba(100,100,100,0.05)",
            cursor: "pointer",
            transition: "background 0.2s"
          }}>
            Cancelar
          </button>
        </div>
      )}
    </form>
  );
}

export default PlanoForm;
